// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"3340":"7e806f08d1032516","4009":"981ac2d5f61e537b","4529":"981ac2d5f61e537b","9610":"54e076e78694c9e5"}[chunkId] + ".css";
};